export enum Compliance {
    MensajeInicioMobile = 'Ingresa un RUT de persona natural y revisa si cuenta con bloqueo por<br>el área de Cumplimiento.',
    MensajeInicioDesktop = 'Ingresa el RUT, nombres y apellidos exactamente como<br> aparecen en la cédula para evitar un posible bloqueo por<br> el área de Cumplimiento.',
}
